import React from 'react';
import PropTypes from 'prop-types';
import IHaveAQuestionButtonPicker
  from 'Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/IHaveAQuestionButtonPicker/IHaveAQuestionButtonPicker';
import { FDBox, FDStack } from '@facet-wealth/design';
import ActionsPicker
  from 'Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/ActionsPicker';


function ListItemActions({
  resource,
  completed,
  handleQuestionOnClick,
  ...rest
}) {
  return (
    <FDBox paddingX={2}>
      <FDStack direction={'row'} spacing={2}>
        <IHaveAQuestionButtonPicker
          resource={resource}
          completed={completed}
          handleQuestionOnClick={handleQuestionOnClick}
          {...rest}
        />
        <ActionsPicker
          resource={resource}
          completed={completed}
          {...rest}
        />
      </FDStack>
    </FDBox>
  );
}

ListItemActions.propTypes = {
  resource: PropTypes.object.isRequired,
  handleQuestionOnClick: PropTypes.func.isRequired,
};

export default ListItemActions;
